var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisconnectRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F4F",
    d: "M1.395.246l16.34 16.34c.32.32.32.836 0 1.156-.159.16-.368.24-.577.24-.21 0-.419-.08-.578-.24L.24 1.402c-.32-.32-.32-.836 0-1.156.32-.32.835-.32 1.155 0zm1.634 7.975l1.572 1.573-1.949 2.03c-.6.626-.636 1.618-.106 2.288l.106.121c.638.665 1.673.665 2.312 0l1.995-2.082 1.573 1.574-2.03 2.117c-.663.692-1.546 1.1-2.477 1.152L3.809 17C1.704 16.999 0 15.219 0 13.024c0-1.051.401-2.06 1.114-2.804l1.915-2zm8.467-6.057c1.488-1.552 3.9-1.552 5.388 0 1.488 1.551 1.488 4.067 0 5.618l-1.921 2.003-1.571-1.571 1.944-2.024c.6-.626.636-1.618.106-2.287l-.106-.122c-.638-.665-1.673-.665-2.31 0l-1.993 2.074-1.572-1.572z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectRed);
export default __webpack_public_path__ + "static/media/disconnect-red.e7fcd0e2deb75b45466bd24fb5bafbfe.svg";
export { ForwardRef as ReactComponent };